function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.921875,24.78125 C15.1796875,24.78125 15.390625,24.6875 15.5703125,24.515625 L21.6484375,18.578125 C21.859375,18.359375 21.96875,18.1328125 21.96875,17.8515625 C21.96875,17.578125 21.8671875,17.3359375 21.6484375,17.1328125 L15.5703125,11.1875 C15.390625,11.015625 15.1796875,10.921875 14.921875,10.921875 C14.3984375,10.921875 13.9921875,11.328125 13.9921875,11.84375 C13.9921875,12.09375 14.1015625,12.3359375 14.2734375,12.515625 L19.75,17.859375 L14.2734375,23.1875 C14.09375,23.375 13.9921875,23.6015625 13.9921875,23.859375 C13.9921875,24.375 14.3984375,24.78125 14.921875,24.78125 Z",
  fill: "#3C4043",
  fillRule: "nonzero"
}));

var SvgNext = function SvgNext(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNext, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/next.1320a5b8.svg";
export { ForwardRef as ReactComponent };